import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CompanyOverview() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="company-overview" ref={ref} className="relative w-full overflow-hidden bg-background py-16 lg:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div className={`relative aspect-[4/3] w-full overflow-hidden rounded-none shadow-xl transition-all duration-1000 ${isVisible ? "translate-x-0 opacity-100" : "-translate-x-10 opacity-0"}`}>
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1569116/img/nucetech_bridge_project_bw.png" alt="Major bridge project by NUCETECH" className="h-full w-full object-cover grayscale transition-transform duration-700 hover:scale-105" />
            {}
            <div className="absolute inset-0 bg-chart-2/60 mix-blend-multiply transition-opacity duration-500 hover:opacity-40" />
            
            {}
            <div className="absolute inset-4 border border-white/30 pointer-events-none" />
          </div>

          {}
          <div className={`flex flex-col justify-center space-y-6 transition-all duration-1000 delay-300 ${isVisible ? "translate-x-0 opacity-100" : "translate-x-10 opacity-0"}`}>
            <div className="space-y-2">
              <h2 className="text-sm font-bold uppercase tracking-widest text-chart-2">
                Giới thiệu
              </h2>
              <h3 className="text-3xl font-bold leading-tight tracking-tight text-foreground md:text-4xl lg:text-5xl">
                Công Nghệ Xây Dựng Tiên Phong Từ{" "}
                <span className="text-primary">2010</span>
              </h3>
            </div>

            <p className="text-lg leading-relaxed text-muted-foreground">
              Công ty Cổ phần Đầu tư và Phát triển Công nghệ Đại học Xây dựng
              (NUCETECH) là một tổ chức định hướng nghiên cứu chuyên sâu vào việc
              chuyển đổi ngành xây dựng.
            </p>

            <p className="text-base leading-relaxed text-muted-foreground">
              Tận dụng chuyên môn từ Trường Đại học Xây dựng Hà Nội, chúng tôi cung
              cấp các giải pháp tư vấn kỹ thuật tiên tiến, chuyển giao công nghệ và
              chuyển đổi số. Sứ mệnh của chúng tôi là thu hẹp khoảng cách giữa
              nghiên cứu học thuật và ứng dụng thực tiễn trong ngành, đảm bảo sự
              phát triển bền vững và sáng tạo cho mọi dự án.
            </p>

            
          </div>
        </div>
      </div>
    </section>;
}